import { Link } from 'react-router-dom';

const footerLinks = {
  产品: [
    { label: '开云下载 Windows版', path: '/' },
    { label: '开云下载 macOS版', path: '/' },
    { label: '开云下载 安卓版', path: '/' },
    { label: '开云下载 iOS版', path: '/' },
  ],
  资源: [
    { label: '软件分类', path: '/category/system-tools' },
    { label: '使用教程', path: '/article/kaiyun-download-latest-version-guide' },
    { label: '常见问题', path: '/about' },
    { label: '更新日志', path: '/article/kaiyun-new-features-2026' },
  ],
  关于: [
    { label: '品牌介绍', path: '/about' },
    { label: '用户口碑', path: '/about' },
    { label: '联系我们', path: '/about' },
    { label: '隐私政策', path: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-download-cloud-2-line text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-bold text-foreground-900 font-heading">开云下载</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              官方正版安全下载平台，提供最新版本极速下载服务。让每一次下载都安全可靠、快速无忧。
            </p>
          </div>
          {Object.entries(footerLinks).map(([group, links]) => (
            <div key={group}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">{group}</h4>
              <ul className="flex flex-col gap-3">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 开云下载 版权所有 | 安全下载，极速体验
          </p>
          <div className="flex items-center gap-4">
            <a href="/" className="text-foreground-500 hover:text-foreground-700 transition-colors" aria-label="微博" rel="nofollow">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="/" className="text-foreground-500 hover:text-foreground-700 transition-colors" aria-label="微信" rel="nofollow">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="/" className="text-foreground-500 hover:text-foreground-700 transition-colors" aria-label="哔哩哔哩" rel="nofollow">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}